import { Top } from "./Com1.style";
export const Com1 = () => {
  return (
    <Top.Wrapper>
      <Top.Background></Top.Background>
      <Top.Container>
        <Top.TextWrapper>
          <Top.Title>스케치 코인 스왑 가이드</Top.Title>
          <Top.Text>보유하고 있는 SKET 토큰의 보유방식을 선택하세요</Top.Text>
        </Top.TextWrapper>
        <img src="/assets/video/img_0.gif" alt="animation1" />
      </Top.Container>
    </Top.Wrapper>
  );
};
